<template>
  <div class="ohm-law-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="circuit-canvas">
      <svg width="100%" height="300" viewBox="0 0 400 300">
        <!-- 导线 -->
        <path d="M 100 200 L 100 100 L 300 100 L 300 200 L 100 200" fill="none" stroke="#555" stroke-width="3" />
        
        <!-- 电子流动画 -->
        <circle v-for="i in 10" :key="'e-'+i" r="3" fill="#00d2ff">
          <animateMotion 
            :dur="electronSpeed + 's'" 
            repeatCount="indefinite" 
            path="M 100 200 L 100 100 L 300 100 L 300 200 L 100 200" 
            :begin="(i * 0.5) + 's'"
          />
        </circle>

        <!-- 电源 (电池) -->
        <g transform="translate(180, 190)">
          <line x1="0" y1="0" x2="40" y2="0" stroke="#aaa" stroke-width="2" />
          <line x1="15" y1="-15" x2="15" y2="15" stroke="#ff4757" stroke-width="4" /> <!-- 正极 -->
          <line x1="25" y1="-8" x2="25" y2="8" stroke="#333" stroke-width="4" /> <!-- 负极 -->
          <text x="10" y="30" fill="#ff4757" font-size="10">U = {{ voltage }}V</text>
        </g>

        <!-- 电阻器 -->
        <g transform="translate(180, 85)">
          <rect x="0" y="0" width="40" height="30" fill="#2c3e50" stroke="#00d2ff" />
          <line x1="5" y1="5" x2="35" y2="5" stroke="#8e44ad" stroke-width="2" />
          <line x1="5" y1="15" x2="35" y2="15" stroke="#f1c40f" stroke-width="2" />
          <line x1="5" y1="25" x2="35" y2="25" stroke="#e67e22" stroke-width="2" />
          <text x="0" y="-10" fill="#00d2ff" font-size="10">R = {{ resistance }}Ω</text>
        </g>

        <!-- 电流表读取 -->
        <g transform="translate(320, 150)">
          <circle r="20" fill="#111" stroke="#aaa" />
          <text text-anchor="middle" y="5" fill="#2ed573" font-size="12">{{ current.toFixed(2) }}A</text>
          <text text-anchor="middle" y="18" fill="#555" font-size="8">A</text>
        </g>
      </svg>
    </div>

    <div class="controls">
      <div class="slider-group">
        <label>电压 (U): {{ voltage }}V</label>
        <el-slider v-model="voltage" :min="1" :max="24" size="mini"></el-slider>
      </div>
      <div class="slider-group">
        <label>电阻 (R): {{ resistance }}Ω</label>
        <el-slider v-model="resistance" :min="1" :max="100" size="mini"></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OhmLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      voltage: 12,
      resistance: 10
    }
  },
  computed: {
    current() {
      return this.voltage / this.resistance;
    },
    electronSpeed() {
      // 电流越大，电子跑得越快 (动画时长越短)
      return Math.max(0.5, 5 / (this.current + 0.1));
    }
  }
}
</script>

<style scoped lang="scss">
.ohm-law-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 15px; }
.viz-header { display: flex; justify-content: space-between; align-items: center; padding: 10px; background: rgba(255,255,255,0.05); .formula { font-family: 'serif'; font-size: 1.4rem; color: #00d2ff; } }
.circuit-canvas { background: #0a0a0a; border-radius: 8px; }
.controls { padding: 15px; background: rgba(255,255,255,0.02); .slider-group { margin-bottom: 10px; label { font-size: 0.85rem; color: #aaa; } } }
</style>
